<template>
  <div class="home">
    <Header />
    <Overview />
    <Feedback />
    <Services />
    <Parallex />
    <Articles />
  </div>
</template>

<script>
import Bound from "bounds.js";

import Header from "@/components/Header";
import Overview from "@/components/Overview";
import Feedback from "@/components/Feedback";
import Services from "@/components/Services";
import Parallex from "@/components/Parallex";
import Articles from "@/components/Articles";

export default {
  components: {
    Header,
    Overview,
    Feedback,
    Services,
    Parallex,
    Articles
  },
  mounted() {
    const boundary = Bound({
      margins: {
        bottom: 100
      }
    }); // initialize with default options
    const image = document.querySelector("img");
    const whenImageEnters = ratio => ratio;
    const whenImageLeaves = ratio => ratio;

    boundary.watch(image, whenImageEnters, whenImageLeaves);
  }
};
</script>